import { Delete01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Button, ButtonVariant, Modal } from "shared/components";

interface DeleteAmenityModalProps {
  opened: boolean;
  label: string;
  loading?: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export const DeleteAmenityModal = ({
  opened,
  label,
  loading,
  onClose,
  onDelete
}: DeleteAmenityModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={() => {
        if (loading) return;
        onClose();
      }}
      panelClassName="w-[366px] items-center flex flex-col p-6"
    >
      <div className="mb-4 rounded-full bg-danger-50 p-4">
        <HugeiconsIcon
          icon={Delete01Icon}
          className="h-8 w-8 text-danger-500"
        />
      </div>
      <p className="mb-2 text-center text-xl font-bold">
        {`Delete "${label}" from amenities options`}
      </p>
      <p className="mb-6 text-content-400 text-sm">
        Are you sure you want to delete this option?
      </p>
      <div className="flex w-full gap-2.5">
        <div className="flex-grow">
          <Button className="w-full" onClick={onClose} disabled={!!loading}>
            Cancel
          </Button>
        </div>
        <div className="flex-grow">
          <Button
            className="w-full"
            variant={ButtonVariant.DANGER}
            loading={!!loading}
            onClick={onDelete}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};
